import React from "react";
import MaestroLoader from "@components/MaestroLoader";
import { Box, Button, CardCover, Grid, Typography } from "@mui/joy";
import TableWidget from "./layouts/TableWidget";
import { primaryProperty, useGetAllBusinesses, useGetBusiness } from "@api/businessService";
import ListWidget from "./layouts/ListWidget";
import { useGetProperty } from "@api/propertyService";
import ObjectPreview from "@components/objects/ObjectPreview";
import { useGetWorkPlan } from "@api/workplanService";
import { formatDate, isValidDate } from "@utils/dates";
import { dueDateClassForTask } from "@utils/dueDateClassForTask";
import { Task } from "@components/Task";
import { useGetAllTasks } from "@api/taskService";
import { useGetAllContacts, useGetContact } from "@api/contactService";

const columns = [
    {
        id: 'address',
        numeric: false,
        disablePadding: true,
        sortable: true,
        label: 'Address',
        cell: (row, {LinkComponent}) => {
            return (<>
                <LinkComponent to={`${row.id}`} relative={true} object={row}>
                    <Typography sx={{display: 'inline-block'}} fontWeight={'bold'}>{row.address}</Typography>
                </LinkComponent>

                {row.address_2 && (<Typography fontSize="sm"><Typography>{row.address_2}</Typography></Typography>)}
            </>)
        }
    },
];

export default function PropertiesByOwnerWidget(props) {
    const service =
        (props?.options?.viewType === 'business')
            ? useGetBusiness
            : useGetContact
    ;

    return (
        <ListWidget
            {...props}
            title={(data, parentData) => (<>Properties Owned by <ObjectPreview object={parentData} to={`/${props?.options?.viewType === 'business' ? 'businesses' : 'contact'}/${parentData.id}`}>{parentData.name}</ObjectPreview></>)}
            query={service}
            relationship={'owned_properties'}
            columns={columns}
        />
    );
}
